// import {PostingOfGoodsGoodDto} from "./PostingOfGoodsGoodDto";
import {IBaseDocumentDto} from "../IBaseDocumentDto";
import { RetailSalesReportPaymentsDto } from "./RetailSalesReportPaymentsDto";
import { RetailSalesReportProductsDto } from "./RetailSalesReportProductsDto";
// import { ReturnOfGOodsFromCustomerGoodsDto } from "./ReturnOfGoodsFromCustomerGoodsDto";

export enum RetailSalesReportPaymentType { 
  cash = 0,
  transfer = 1,
  bank = 2,
  vouchers = 3,
  giftCards = 4
}
export interface CreateRetailSalesReportDto extends IBaseDocumentDto {
  baseDocumentAtId?: string;
  createdDate?: Date;
  warehouseId?: string;
  cashRegisterRetailId?: string;
  cashierShiftId?: string;
  products: RetailSalesReportProductsDto[];
  payment:RetailSalesReportPaymentsDto[];
}